var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "search-tree" },
    [
      _c(
        "el-popover",
        {
          ref: "popover",
          attrs: { placement: "bottom", width: "250", trigger: "click" },
        },
        [
          _c("el-tree", {
            ref: "tree",
            staticClass: "filter-tree",
            attrs: {
              data: _vm.data,
              "node-key": "id",
              "show-checkbox": _vm.showCheckbox,
              props: _vm.defaultProps,
              "default-expand-all": "",
              "current-node-key": _vm.checkedNodeId,
              "filter-node-method": _vm.filterNode,
            },
            on: {
              "node-click": _vm.getCheckedKeys,
              "check-change": _vm.getCheckedKeys,
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "search-box",
              attrs: { slot: "reference" },
              on: { click: _vm.showDown },
              slot: "reference",
            },
            [
              _vm.checkedNodes.length > 0
                ? _c(
                    "div",
                    _vm._l(_vm.checkedNodes, function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "selected-box" },
                        [
                          _c("span", { staticClass: "txt" }, [
                            _vm._v(_vm._s(item.name)),
                          ]),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "el-icon-error",
                            on: {
                              click: function ($event) {
                                return _vm.deleteNode(index, item.id)
                              },
                            },
                          }),
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-box" },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请选择" },
                    model: {
                      value: _vm.filterText,
                      callback: function ($$v) {
                        _vm.filterText = $$v
                      },
                      expression: "filterText",
                    },
                  }),
                  _vm._v(" "),
                  _vm.isShowDown
                    ? _c("i", { staticClass: "el-icon-caret-bottom" })
                    : _c("i", { staticClass: "el-icon-caret-top" }),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }